











































































































































































































































































































































































































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator';

import { AccountInfo } from "@azure/msal-browser";
import { BusyList, BusyObject } from '@/models/Busy';
import { BrandBookmarkContainer, BrandBookmarkContainersService, BrandQueriesService, BrandQueryExecutionOptions, BrandQueryHistoryItem, BrandQueryHistoryService, BrandQueryResult, StoredBrandQueriesService, StoredBrandQuery } from '@/api/braendz';
import { RobotOption } from '@/models/MetaTags';
import { IdTokenClaim } from '@/models/IdTokenClaim';

import Label from '@/components/Label.vue';

import DashboardCard from '@/components/Dashboard/DashboardCard.vue';
import BrandBookmarkContainerViewer from '@/components/BrandBookmarks/BrandBookmarkContainerViewer.vue';
import ConfirmationPopup from '@/components/Popups/ConfirmationPopup.vue';

import ConfigureStoredBrandQueryPopup from '@/components/StoredBrandQueries/ConfigureStoredBrandQueryPopup.vue';
import BrandQueryHistory from '@/components/BrandQueryResults/BrandQueryHistory.vue';
import BrandQueryResultPopup from '@/components/BrandQueryResults/BrandQueryResultPopup.vue';
import BrandQueryResultView from '@/components/BrandQueryResults/BrandQueryResultView.vue';
import LoadingView from '@/components/Spinner/LoadingView.vue';

@Component({
    components: {
        Label,
        DashboardCard,
        BrandBookmarkContainerViewer,
        ConfirmationPopup,
        BrandQueryHistory,
        ConfigureStoredBrandQueryPopup,
        BrandQueryResultPopup,
        BrandQueryResultView,
        LoadingView
    },
    metaInfo() {
        return {
            title: this.$i18n.t("myBraendz.title").toString(),
            meta: [
                { name: 'robots', content: [RobotOption.NoIndex, RobotOption.NoFollow].join(',') }
            ]
        };
    }
})
export default class MyBraendz extends Vue {
    // Properties
    public navigationVisible = true;
    public selectedItem: BrandBookmarkContainer | StoredBrandQuery | null | undefined = null;
    public brandBookmarkContainerView: 'carousel' | 'list' | 'slider' | 'grid' = this.$vuetify.breakpoint.mdAndUp ? 'carousel' : 'list';

    public brandBookmarkContainers = new BusyList<BrandBookmarkContainer>();
    public storedBrandQueries = new BusyList<StoredBrandQuery>();

    public brandQueryHistoryView: 'carousel' | 'list' | 'slider' | 'grid' = 'carousel';
    public newHistoryItem = new BusyObject<BrandQueryHistoryItem>();
    public brandQueryResultView: 'carousel' | 'list' | 'slider' | 'vertical-grid' | 'horizontal-grid' = 'vertical-grid';
    public saveStoredBrandQueryResult = false;

    // BrandQueryResultPopup:
    public showBrandQueryResultPopup = false;
    public brandQueryResultPopupHistoryItem: BrandQueryHistoryItem | null = null;
    public brandQueryResultPopupStoredBrandQuery: StoredBrandQuery | null = null;
    public brandQueryResult = new BusyObject<BrandQueryResult>();
    BusyReason: any;


    // Getter & Setter
    public get isInitializing(): boolean {
        return (this.brandBookmarkContainers.isBusy && this.brandBookmarkContainers.reason === 'Loading' )
            || (this.storedBrandQueries.isBusy && this.storedBrandQueries.reason === 'Loading');
    }

    public get userAccount(): AccountInfo | null {
        return this.$store.state.userAccount;
    }

    public get userFirstname(): string | null {
        return (this.userAccount?.idTokenClaims as IdTokenClaim)?.given_name ?? null;
    }

    public get userDisplayName(): string | null {
        return this.userAccount?.name ?? this.userAccount?.username ?? null;
    }

    public get collapsableNavigation(): boolean {
        return this.$vuetify.breakpoint.mdAndDown;
    }

    public get showNavigation(): boolean {
        return !this.collapsableNavigation || this.navigationVisible;
    }
    public set showNavigation(value: boolean) {
        this.navigationVisible = value;
    }

    public get selectedBrandBookmarkContainer(): BrandBookmarkContainer | null {
        if(!this.selectedItem) return null;
        else if("brandBookmarks" in this.selectedItem) return this.selectedItem;
        else return null;
    }

    public get selectedStoredBrandQuery(): StoredBrandQuery | null {
        if(!this.selectedItem) return null;
        else if("agentExecutionFrequency" in this.selectedItem) return this.selectedItem;
        else return null;
    }

    // Watchers

    // Lifecycle Methods:
    public mounted(): void {
        // Initialize some stuff here:
        this.refreshBrandBookmarkContainers();
        this.refreshStoredBrandQueries();
    }

    // Methods:
    public buildKey(item: BrandBookmarkContainer | StoredBrandQuery | string, index?: number): string {
        const suffix = index !== undefined ? `_${index}` : '';
        if(typeof item === 'string') return `${item}${suffix}`;
        else if("brandBookmarks" in item) return `BrandBookmarkContainer_${item.id}${suffix}`;
        else return `StoredBrandQuery_${item.id}${suffix}`;
    }

    public async refreshBrandBookmarkContainers() {
        await this.brandBookmarkContainers.load(async () => {
            return await BrandBookmarkContainersService.getBrandBookmarkContainersCurrentUserDefaultAccount();
        });
    }

    public async refreshStoredBrandQueries() {
        await this.storedBrandQueries.load(async () => {
            return await StoredBrandQueriesService.getStoredBrandQueriesCurrentUserDefaultAccount();
        });
    }

    public async deleteContainer(container: BrandBookmarkContainer) {
        await this.brandBookmarkContainers.delete(async () => {
            if(!container.id) {
                return null;
            }
            await BrandBookmarkContainersService.deleteBrandBookmarkContainer(container.id);
            return container;
        });
    }

    public async executeNewHistoryItem() {
        if(!this.selectedStoredBrandQuery?.id) return;

        const newHistoryItem =await this.newHistoryItem.create(async () => {
            if(!this.selectedStoredBrandQuery?.id) {
                return null;
            }
            return await BrandQueryHistoryService.createBrandQueryHistoryItem(this.selectedStoredBrandQuery.id);
        })

        const selectedStoredBrandQueryHistory = this.$refs.selectedStoredBrandQueryHistory as BrandQueryHistory;

        if(newHistoryItem && selectedStoredBrandQueryHistory) {
            selectedStoredBrandQueryHistory.addHistoryItem(newHistoryItem);
        }
    }

    public async executeStoredBrandQuery(storedBrandQuery: StoredBrandQuery) {
        await this.brandQueryResult.create(async () => {
            if(storedBrandQuery.id) {
                const result = await BrandQueriesService.executeBrandQueryById(storedBrandQuery.id, { storeResult: this.saveStoredBrandQueryResult });

                const selectedStoredBrandQueryHistory = this.$refs.selectedStoredBrandQueryHistory as BrandQueryHistory;
                let resultHistoryItem: BrandQueryHistoryItem | null = null;
                if(result.id && selectedStoredBrandQueryHistory) {
                    resultHistoryItem = await BrandQueryHistoryService.getBrandQueryHistoryItem(result.id)
                    selectedStoredBrandQueryHistory.addHistoryItem(resultHistoryItem);
                }
                this.showStoredBrandQueryResultPopup(storedBrandQuery, resultHistoryItem, result);
                return result;
            }
            return null;
        });
    }

    public async deleteStoredBrandQuery(storedBrandQuery: StoredBrandQuery): Promise<void> {
        await this.storedBrandQueries.delete(async () => {
            if(!storedBrandQuery.id) {
                return null;
            }
            await StoredBrandQueriesService.deleteStoredBrandQuery(storedBrandQuery.id);
            return storedBrandQuery;
        });
    }

    public showStoredBrandQueryResultPopup(query?: StoredBrandQuery | null, historyItem?: BrandQueryHistoryItem | null, result?: BrandQueryResult | null): void {
        this.brandQueryResultPopupStoredBrandQuery = query ?? null;
        this.brandQueryResultPopupHistoryItem = historyItem ?? null;

        if(result) {
            this.brandQueryResult.object = result;
        } else {
            this.brandQueryResult.reset();
        }

        this.showBrandQueryResultPopup = true;
    }
}
